type TextReadOnlyCellProps = {
  value: any;
  onClick?: (e: any) => void;
};

export default function TextReadOnlyCell(props: TextReadOnlyCellProps) {
  return (
    <div
      style={{
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        width: "100%",
      }}
      onClick={(e) => {
        e.stopPropagation();
        if (props.onClick) {
          props.onClick(e);
        }
      }}
    >
      {props.value}
    </div>
  );
}
